import { ChangeDetectionStrategy, Component, input } from '@angular/core'

export enum KuutionTila {
  VAPAA = 'vapaa',
  VAPAA_TALLENNETAAN = 'vapaa-tallennetaan',
  REKISTERI = 'rekisteri',
  REKISTERI_PAIVITETAAN = 'rekisteri-paivitetaan',
}

@Component({
  selector: 'app-kuutio-ikoni',
  templateUrl: './kuutio-ikoni.component.html',
  styleUrls: ['./kuutio-ikoni.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KuutioIkoniComponent {
  readonly tila = input<KuutionTila>(KuutionTila.VAPAA)
  readonly koko = input(20)

  kuutionTilat = KuutionTila
}
